// frontend/src/api.js

// const API_URL = 'http://localhost:5000/api';
const API_URL = 'https://azadi.ae/api';

let userRole = null; // will be set on login

export function setUserRole(role) {
  userRole = role;
}

async function fetchAPI(endpoint, options = {}) {
  // Detect if body is FormData
  const isFormData = options.body instanceof FormData;

  options.headers = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...(userRole ? { 'x-role': userRole } : {}),
    ...options.headers,
  };

  const res = await fetch(`${API_URL}${endpoint}`, options);
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || 'API Error');
  }
  return res.json();
}

export const api = {
  login: (username, password) =>
    fetchAPI('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    }),

  getUsers: () => fetchAPI('/users'),
  addUser: (user) =>
    fetchAPI('/users', {
      method: 'POST',
      body: JSON.stringify(user),
    }),
  updateUser: (id, user) =>
    fetchAPI(`/users/${id}`, {
      method: 'PUT',
      body: JSON.stringify(user),
    }),
  deleteUser: (id) =>
    fetchAPI(`/users/${id}`, {
      method: 'DELETE',
    }),

  getProductTypes: () => fetchAPI('/products/types'),

  getProductsByType: (type) => fetchAPI(`/products/type/${type}`),

  getSubTypesByType: (type) => fetchAPI(`/products/subtypes/${type}`),

getProductsByTypeAndSubType: (type, subType) =>
  fetchAPI(`/products/type/${type}`).then(products =>
    products.filter(p => p.subType === subType)
  ),

  getAllProducts: () => fetchAPI('/products'),

  addProduct: (formData) =>
    fetchAPI('/products', {
      method: 'POST',
      body: formData, // FormData object (do NOT stringify)
    }),

  updateProduct: (id, formData) =>
    fetchAPI(`/products/${id}`, {
      method: 'PUT',
      body: formData, // FormData object
    }),
  // addProduct: (product) =>
  //   fetchAPI('/products', {
  //     method: 'POST',
  //     body: JSON.stringify(product),
  //   }),

  // updateProduct: (id, product) =>
  //   fetchAPI(`/products/${id}`, {
  //     method: 'PUT',
  //     body: JSON.stringify(product),
  //   }),

  deleteProduct: (id) =>
    fetchAPI(`/products/${id}`, {
      method: 'DELETE',
    }),

  getOrders: () => fetchAPI('/orders'),
  createOrder: (order) =>
    fetchAPI('/orders', {
      method: 'POST',
      body: JSON.stringify(order),
    }),

    updateOrder: (id, order) =>
      fetchAPI(`/orders/${id}`, {
        method: 'PUT',
        body: JSON.stringify(order),
      }),
  
    deleteOrder: (id) =>
      fetchAPI(`/orders/${id}`, {
        method: 'DELETE',
      }),
  
};
